import { render, staticRenderFns } from "./MenuContainer.vue?vue&type=template&id=a9af1250&scoped=true&"
import script from "./MenuContainer.vue?vue&type=script&lang=js&"
export * from "./MenuContainer.vue?vue&type=script&lang=js&"
import style0 from "./MenuContainer.vue?vue&type=style&index=0&id=a9af1250&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9af1250",
  null
  
)

export default component.exports